import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface StatisticsData {
        usersCount: number;
        addressesCount: number;
        topAddressesByPincode: { pinCode: string; addressCount: number }[];
    }

export const GetStatisticsOfUsersAndAddressAsync = async (
    fromDate: string,
    toDate: string,
    token: string
  ): Promise<StatisticsData> => {
    const baseUrl = getApiBaseUrl();
    const apiUrl = `${baseUrl}/api/Admin/GetStatisticsOfUsersAndAddressAsync?fromDate=${fromDate}&toDate=${toDate}`;
  
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error(`Failed to fetch statistics: ${response.status}`);
      }
  
      return await response.json();
    } catch (error) {
      // console.error('Error in GetStatisticsOfUsersAndAddressAsync:', error);
      throw error;
    }
  };
  